import { Component, inject, signal } from '@angular/core';
import { IconComponent, SectionLinkDirective, SectionNavigationService } from '../../shared';
import { NAV_LINKS } from '../../content/home.content';

@Component({
  selector: 'app-navbar',
  imports: [IconComponent, SectionLinkDirective],
  templateUrl: './navbar.component.html',
  host: {
    '(document:keydown.escape)': 'menuOpen.set(false)'
  }
})
export class NavbarComponent {
  readonly links = NAV_LINKS;
  readonly activeSection = inject(SectionNavigationService).activeSection;
  readonly menuOpen = signal(false);
}
